import React from 'react'
import ButtonBase from '@mui/material/ButtonBase'
import Menu from '@mui/material/Menu'
import Typography from '@mui/material/Typography'
import ExpandMore from '@mui/icons-material/ExpandMore'

interface Props {
  key?: string | number
  label?: string
  children?: React.ReactNode
  contrast?: boolean
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'body1' | 'body2'
  bold?: boolean
}

const NavDropdown = ({
  label,
  children,
  contrast = false,
  variant = 'body2',
  bold = false,
}: Props) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  return (
    <>
      <ButtonBase
        onClick={handleClick}
        sx={{
          '&:hover': {
            color: 'primary.main',
          },
        }}
      >
        <Typography
          variant={variant}
          sx={{
            cursor: 'pointer',
            color: contrast ? 'primary.contrastText' : 'text.primary',
            fontWeight: bold ? 'medium' : 'normal',
            pr: 1,
            '&:hover': {
              color: 'primary.main',
            },
          }}
        >
          {label}
        </Typography>
        <ExpandMore
          sx={{
            position: 'absolute',
            right: -15,
            top: -2,
            cursor: 'pointer',
            transform: `rotate(${open ? '180deg' : '0deg'})`,
          }}
        />
      </ButtonBase>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {children}
      </Menu>
    </>
  )
}

export default NavDropdown
